<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('活动标题')">
                <a-input v-model="queryParam.activityTitle" :placeholder="$t('请输入')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('活动状态')">
                <a-select v-model="queryParam.activityStatus" :placeholder="$t('请选择')">
                  <a-select-option v-for="item in activityStatusArr" :key="item.value" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('是否置顶')">
                <a-select v-model="queryParam.commendFlag" :placeholder="$t('请选择')">
                  <a-select-option v-for="item in commendFlagArr" :key="`zhiding-${item.value}`" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建时间')">
                  <cy-range-picker
                    :start.sync="queryParam.createBeginTime"
                    :end.sync="queryParam.createEndTime"
                  ></cy-range-picker>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['cooking:activity:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['problem:type:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cooking:activity:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['cooking:dev:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 详情 -->
      <detail-form v-if="detailVisible" ref="detailForm" @refresh="getList" @close="detailVisible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="activityImgUrl" slot-scope="text, record">
          <div v-viewer>
            <img style="width: 50px; height: 50px" :src="record.activityImgUrl" alt="" srcset="" />
          </div>
        </span>
        <span slot="activityStatus" slot-scope="text, record">
          {{ record.activityStatus | filterCommon(activityStatusArr, 'label') }}
        </span>
        <span slot="commendFlag" slot-scope="text, record">
          {{ record.commendFlag | filterCommon(commendFlagArr, 'label') }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['cooking:activity:zd']" />
          <a @click="handleZd(record.id)" v-hasPermi="['cooking:activity:zd']">
            {{ record.commendFlag == 0 ? $t('取消置顶') : $t('置顶') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:activity:query']" />
          <a @click="handleDetail(record.id)" v-hasPermi="['cooking:activity:query']">
            {{ $t('详情') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:activity:edit']" />
          <a @click="handleAdd(record.id)" v-hasPermi="['cooking:activity:edit']">
            {{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['cooking:activity:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['cooking:activity:remove']">
            {{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delObj, fetchList, putTop } from './api'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/Detail'
import CyRangePicker from '@/components/CyRangePicker'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Type',
  components: {
    CreateForm,
    DetailForm,
    CyRangePicker
  },
  mixins: [tableMixin],
  data() {
    return {
      detailVisible: false,
      commendFlagArr: [
        { value: 0, label: this.$t('是') },
        { value: 1, label: this.$t('否') }
      ],
      activityStatusArr: [
        { value: 0, label: this.$t('未开始') },
        { value: 1, label: this.$t('进行中') },
        { value: 2, label: this.$t('已结束') },
        { value: 3, label: this.$t('取消') }
      ],
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        activityStatus: undefined,
        activityTimes: undefined,
        activityTitle: undefined,
        commendFlag: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      },
      columns: [
        // { title: 'id', dataIndex: 'id', align: 'center', ellipsis: true },
        { title: this.$t('标题'), dataIndex: 'activityTitle', align: 'center', ellipsis: true },
        {
          title: this.$t('图片'),
          dataIndex: 'activityImgUrl',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'activityImgUrl' }
        },
        { title: this.$t('开始时间'), dataIndex: 'activityStart', align: 'center', ellipsis: true },
        { title: this.$t('结束时间'), dataIndex: 'activityEnd', align: 'center', ellipsis: true },
        {
          title: this.$t('活动状态'),
          dataIndex: 'activityStatus',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'activityStatus' }
        },
        {
          title: this.$t('是否置顶'),
          dataIndex: 'commendFlag',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'commendFlag' }
        },
        { title: this.$t('点赞'), dataIndex: 'dz', align: 'center', ellipsis: true },
        { title: this.$t('收藏数'), dataIndex: 'scCount', align: 'center', ellipsis: true },
        { title: this.$t('评论数'), dataIndex: 'commentCount', align: 'center', ellipsis: true },
        { title: this.$t('排序'), dataIndex: 'sort', align: 'center', ellipsis: true },
        {
          title: this.$t('发布时间'),
          dataIndex: 'publicTime',
          scopedSlots: { customRender: 'publicTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    handleZd(id) {
      putTop({ id }).then((res) => {
        this.getList()
      })
    },
    handleDetail(id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detailForm.init(id)
      })
    },
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.createForm.init(id)
        }, 100)
      })
    },
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        activityStatus: undefined,
        activityTimes: undefined,
        activityTitle: undefined,
        commendFlag: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出?'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            'problem/type/export',
            {
              ...that.queryParam
            },
            `常见问题分类_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
